import React, { useEffect, useState } from "react";
import api from "../../../utils/axios";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import CalendarWrapper from "../../components/Calendar/CalendarWrapper";

export default function SaleCustomerCalendar() {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(false);

  const breadcrumbs = [
    { label: "ขาย", link: "/sale" },
    { label: "ปฏิทินเข้าพบลูกค้า" },
  ];

  const fetchData = async () => {
    setLoading(true);
    try {
      // ดึง role และ emp_id จาก localStorage
      const role = localStorage.getItem("role");
      const roleCode = localStorage.getItem("role_code");
      const empId = localStorage.getItem("emp_id");
      
      // ส่ง role และ emp_id ไปกับ request เพื่อให้ backend ตรวจสอบ
      const params = {};
      if (role) params.role = role;
      if (roleCode) params.role_code = roleCode;
      if (empId) params.emp_id = empId;
      
      const res = await api.get("/get-tb-set-ar-calendar", { params });
      setAppointments(res.data.results || res.data.result || []);
    } catch (err) {
      console.error("โหลดข้อมูลปฏิทิน Error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Sidebar />
      <Topbar className="pl-0" breadcrumbs={breadcrumbs} />

      {/*  Layout แบบเดียวกับหน้า Report */}
      <div
        className="pl-2 pr-8 pt-3 pb-6"
        style={{
          marginLeft: "var(--sidebar-width)",
          marginTop: "40px",
          backgroundColor: "#f8f9fa",
          minHeight: "calc(100vh - 56px)",
        }}
      >
        <div
          className="card table-card border-0 rounded-0 shadow-sm bg-white"
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "8px 12px",
          }}
        >
          <style>{`
            * { font-size: 14px !important; }
          `}</style>

          {/*  หัวเรื่อง */}
          <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2 px-2 pt-2">
            <h3 className="fw-bold text-gray-700 fs-5">ปฏิทินการเข้าพบ</h3>
          </div>

          {/*  เนื้อหาปฏิทิน */}
          <div
            className="flex-1"
            style={{ padding: "6px 8px", minHeight: "600px" }}
          >
            {loading ? (
              <div className="text-center py-4 text-muted">
                กำลังโหลดข้อมูล...
              </div>
            ) : (
              <CalendarWrapper 
                  appointments={appointments} 
                  refreshAppointments={fetchData}
              />

            )}
          </div>
        </div>
      </div>
    </>
  );
}
